export const EMAIL_PATTERN: RegExp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PASSWORD_PATTERN: RegExp = /^(?=.*\p{Ll})(?=.*\p{Lu}).{8,20}$/u;
export const ALPHABETIC_STRING_PATTERN: RegExp = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
export const QR_CODE_PATTERN: RegExp = /^@[^@]*$/;
export const PHONE_NUMBER_PATTERN: RegExp = /^\+?[1-9][\d\s]{1,14}$/;
export const ARM_PHONE_NUMBER_PATTERN: RegExp = /^\+?[1-9][\d\s]{7}$/;
export const HASHTAGS_MAX_LENGTH: number = 3;
